import { ApiService } from '../../services/api_service';
import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { DatenauswertungJahrauswahlEinzeln } from '../datenauswertung/DatenauswertungJahrauswahlEinzeln';
import { getVsmeBpmEntities } from './assistent/items/assistent_config_vsme_bpm';
import { getVsmePatEntities } from './assistent/items/assistent_config_vsme_pat';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import style from '../../default.less';
import { TriggerService } from '../../core/trigger/trigger_service';
import { StructureService } from '../../services/structure_service';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WSpinner } from '../../core/elements/spinner/WSpinner';

interface DateneingabeVSMEAuswahlProps extends React.ClassAttributes<any> {
    category: string;
    data: any;
    standortSelected: any;
    jahrFix?: number;
    hideJahr?: boolean;
    showHelpIcon?: boolean;
    onClose?: () => void;
}

interface DateneingabeVSMEAuswahlState {
    jahr: number;
    jahrMax: number;
    jahrMin: number;
    auswahlData: Array<any>;
    showSpinner: boolean;
}

export class DateneingabeVSMEAuswahl extends React.Component<DateneingabeVSMEAuswahlProps, DateneingabeVSMEAuswahlState> {

    constructor(props: any) {
        super(props);
        this.domId = `DateneingabeVSMEAuswahl_${props.category}`;
        const jahr_context = this.contextService.get(`jahr_${props.category}_auswahl`);
        const startjahr: number = ((this.props.data[IDs.ENT_KONFIGURATION] || [])
            .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
        const jahrMax: number = new Date().getFullYear() - 1;
        const jahrMin: number = +startjahr > 1900 ? startjahr : 2010;
        this.state = {
            jahr: this.props.jahrFix || jahr_context || jahrMax,
            jahrMax,
            jahrMin,
            auswahlData: [],
            showSpinner: false
        };
        this.copyVorjahr = this.copyVorjahr.bind(this);
    }

    private domId: string;
    private saveHandle = -1;

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(StructureService) private structureService: StructureService;

    componentDidMount(): void {
        this.setAuswahlData();
    }

    setAuswahlData(dataRows?: Array<any>) {
        const auswahlData: Array<any> = (dataRows || this.props.data[IDs.ENT_VSME_AUSWAHL] || [])
            .filter((a: any) => a.category === this.props.category && a.standort_tid_orig === this.props.standortSelected.tid)
            .map((a: any) => { return { ...a } });
        this.setState({ auswahlData });
    }

    onChangeAuswahl(key: string, auswahl: boolean): void {
        const { auswahlData } = this.state;
        const idx = auswahlData.findIndex((r: any) =>
            r.jahr === this.state.jahr
            && (r.standort_tid_orig === this.props.standortSelected.tid || r.standort_tid === this.props.standortSelected.tid)
            && r.name === key
            && r.category === this.props.category
        );
        if (idx === -1) {
            auswahlData.push({
                tid: 0,
                standort_tid: this.props.standortSelected.tid,
                standort_tid_orig: this.props.standortSelected.tid,
                jahr: this.state.jahr,
                name: key,
                auswahl: auswahl ? 1 : 0,
                hinweis: '',
                category: this.props.category
            });
        } else {
            auswahlData[idx].auswahl = auswahl ? 1 : 0;
        }
        this.setState({ auswahlData }, this.saveDelayed);
    }

    saveDelayed(): void {
        const handle = window.setTimeout(() => {
            if (handle === this.saveHandle) {
                // console.log('Save now!');
                this.saveNow(false);
            } else {
                // console.log('Save discarded!');
            }
        }, 1000);
        this.saveHandle = handle;
        this.onDelayedSaving(true);
    }

    onDelayedSaving(isSaving: boolean) {
        const closeBtn = document.getElementsByClassName("ui-dialog-titlebar-close");
        if (closeBtn.length > 0) {
            isSaving ?
                closeBtn[0].setAttribute('disabled', 'disabled') :
                closeBtn[0].removeAttribute('disabled');

        }
    }

    saveNow(closeAfter: boolean): boolean {
        const saveList: Array<any> = [];
        const auswahlData = this.state.auswahlData;
        const auswahlDataLoaded = this.props.data[IDs.ENT_VSME_AUSWAHL].filter((r: any) => r.category === this.props.category);
        auswahlData.forEach((row: any) => {
            const foundLoaded = auswahlDataLoaded.find((rl: any) =>
                rl.name === row.name
                && (rl.standort_tid_orig === row.standort_tid || rl.standort_tid_orig === row.standort_tid_orig)
                && rl.jahr === row.jahr
                && rl.category === row.category
            );
            if (foundLoaded) {
                if (foundLoaded.auswahl !== row.auswahl || foundLoaded.hinweis !== row.hinweis) {
                    if (row.standort_tid_orig) {
                        row.standort_tid = row.standort_tid_orig;
                    }
                    saveList.push(row);
                }
            } else {
                saveList.push(row);
            }
        });
        if (saveList.length > 0) {
            this.setState({ showSpinner: true }, () => {
                this.dataService.saveDataList(IDs.ENT_VSME_AUSWAHL, saveList, () => {
                    this.triggerService.fire('reload', IDs.ENT_VSME_AUSWAHL, (data: any) => {
                        this.onDelayedSaving(false);
                        this.setState({ showSpinner: false });
                        this.setAuswahlData(data[IDs.ENT_VSME_AUSWAHL]);
                    });
                    if (closeAfter) {
                        if (this.props.onClose) {
                            alert('Die Auswahl des Vorjahres wurde übernommen! Der Auswahl-Dialog wird geschlossen!');
                            this.props.onClose();
                        } else {
                            alert('Die Auswahl des Vorjahres wurde übernommen!');
                        }
                    }
                }, IDs.MOD_ETOOL);
            });
            return true;
        } else {
            return false;
        }
    }

    copyVorjahr(testOnly: boolean) {
        if (!testOnly && !confirm('Soll die aktuelle Auswahl durch die Auswahl des Vorjahres überschrieben werden?')) {
            return;
        }
        let auswahlData: Array<any> = [];
        if (testOnly) {
            auswahlData = this.state.auswahlData.map((a: any) => { return { ...a } })
        } else {
            auswahlData = this.state.auswahlData;
        }
        const auswahlLastYear = auswahlData.filter((r: any) =>
            r.jahr === (this.state.jahr - 1) && r.standort_tid_orig === this.props.standortSelected.tid
        );
        auswahlLastYear.forEach((item: any) => {
            // versuchen wir den aktuellen Eintrag zu finden
            const row = auswahlData.find((r: any) =>
                r.jahr === this.state.jahr && r.standort_tid_orig === this.props.standortSelected.tid && r.name === item.name
            );
            // Fallunterscheidung
            if ((!item.auswahl && !item.hinweis) && (!row || !row.auswahl)) {
                // Alles klar... brauchen nichts machen
            } else if (item.auswahl && row && row.auswahl) {
                // Alles klar... brauchen nichts machen
            } else if ((item.auswahl || item.hinweis) && !row) {
                // Row anlegen da Auswahl noch nicht existiert
                const row_copy = { ...item };
                row_copy.tid = 0;
                row_copy.jahr = this.state.jahr;
                row_copy.standort_tid = item.standort_tid_orig;
                auswahlData.push(row_copy);
            } else if (item.auswahl && row && !row.auswahl) {
                // Einfach aktivieren
                row.auswahl = 1;
            } else if (!item.auswahl && row && (row.auswahl || item.hinweis)) {
                // Einfach deaktivieren
                row.auswahl = 0;
                if (item.hinweis) {
                    row.hinweis = item.hinweis;
                }
            }
        });
        // Jetzt noch die Entfernen, die es im Vorjahr gar nicht gibt
        auswahlData
            .filter((r: any) => r.jahr === this.state.jahr && r.standort_tid_orig === this.props.standortSelected.tid)
            .forEach((item: any) => {
                // versuchen wir den aktuellen Eintrag zu finden
                // Achtung, hier ist die Bezeichnung umgedreht... item ist aus auswahlData und nicht das Vorjahr
                const row = auswahlData.find((r: any) =>
                    (r.jahr === this.state.jahr - 1) && r.standort_tid_orig === this.props.standortSelected.tid && r.name === item.name
                );
                if (!row) {
                    item.auswahl = 0;
                }
            });

        if (testOnly) {
            return this.checkNow(auswahlData);
        }

        this.setState({ auswahlData }, () => {
            this.saveNow(true);
        });
    }

    checkNow(auswahlData: Array<any>): boolean {
        const saveList: Array<any> = [];
        const auswahlDataLoaded = this.props.data[IDs.ENT_VSME_AUSWAHL].filter((r: any) => r.category === this.props.category);
        auswahlData.forEach((row: any) => {
            const foundLoaded = auswahlDataLoaded.find((rl: any) =>
                rl.name === row.name
                && (rl.standort_tid_orig === row.standort_tid || rl.standort_tid_orig === row.standort_tid_orig)
                && rl.jahr === row.jahr
                && rl.category === row.category
            );
            if (foundLoaded) {
                if (foundLoaded.auswahl !== row.auswahl || foundLoaded.hinweis !== row.hinweis) {
                    if (row.standort_tid_orig) {
                        row.standort_tid = row.standort_tid_orig;
                    }
                    saveList.push(row);
                }
            } else {
                saveList.push(row);
            }
        });
        if (saveList.length > 0) {
            return true;
        } else {
            return false;
        }
    }

    render(): JSX.Element {
        const hasVorjahr = this.state.auswahlData.some((r: any) =>
            r.jahr === (this.state.jahr - 1) && r.auswahl && r.standort_tid_orig === this.props.standortSelected.tid
        );

        let structVsme;
        switch (this.props.category) {
            case 'vsme_pat':
                structVsme = getVsmePatEntities();
                break;
            case 'vsme_bpm':
                structVsme = getVsmeBpmEntities();
                break;
        }

        const checkVorjahr = this.copyVorjahr(true);
        return (
            <div id={this.domId} className={style.colContainer}>
                <div className={style.rowContainer} style={{ alignItems: 'center', justifyContent: 'space-between', paddingTop: 5, marginBottom: 5 }}>
                    <div style={{ display: 'flex', alignItems: 'baseline' }}>
                        {!this.props.hideJahr && this.renderJahresauswahl()}
                        <button
                            onClick={() => this.copyVorjahr(false)}
                            disabled={!hasVorjahr || !checkVorjahr}
                            style={{
                                height: '24px', cursor: (hasVorjahr && checkVorjahr) ? 'pointer' : 'no-drop', border: '1px solid',
                                backgroundColor: (hasVorjahr && checkVorjahr) ? 'var(--color-wform-background)'/*'#eee'*/ : '#eee',
                                color: (hasVorjahr && checkVorjahr) ? '#000' : '#aaa'
                            }}
                        >
                            Auswahl aus Vorjahr übernehmen
                        </button>
                    </div>
                </div>
                <div className={style.rowContainer} style={{ backgroundColor: 'white', width: '100%' }}>
                    <div className={style.colContainer} style={{ maxWidth: 600, minWidth: 600 }}>
                        {this.renderHeader(false, true)}
                        {(structVsme || []).filter((item: any) => item.key).map((item: any, idx: number) => this.renderRow(item, idx + 1000))}
                    </div>
                </div>
                {this.state.showSpinner && <WSpinner label='Speichern' />}
            </div>
        );
    }

    renderRow(item: any, idx: number): JSX.Element {
        const row = this.state.auswahlData.find((r: any) =>
            r.jahr === this.state.jahr && r.standort_tid_orig === this.props.standortSelected.tid && r.name === item.key
        );
        const auswahl = (row && row.auswahl) ? true : false;
        const structure = this.structureService.getStructureByKey(IDs.MOD_ETOOL, item.key) || {};
        return <div
            className={style.rowContainer}
            style={{ marginBottom: 2, minHeight: 40 }}
            key={`div_${this.props.category}_row_${idx}`}
        >
            <div
                style={{
                    backgroundColor: 'var(--color-wform-background)'/*'#eee'*/, minWidth: 40, maxWidth: 40, padding: 2, textAlign: 'center',
                    boxSizing: 'border-box', paddingTop: 12
                }}
            >
                <WHelpIcon
                    data={this.props.data}
                    styleDivProps={{ marginLeft: 8, display: 'flex', alignSelf: 'center' }}
                    styleProps={{ margin: 0 }}
                    label={item.name || structure.TITEL}
                    helpKey={`auswahl_${item.key}`}
                    type='theme_info'
                    style='theme_small'
                    editBar={this.apiService.isAdmin()}
                    useTheme
                    // type='info'
                    // styleDivProps={{ display: 'inline-block' }}
                    // styleProps={{
                    //     width: 16, height: 16, borderRadius: 10, backgroundColor: 'var(--color-section-main)'/*'#bccae3'*/,
                    //     verticalAlign: 'top', margin: 0
                    // }}
                />
            </div>
            <div
                style={{
                    backgroundColor: 'var(--color-wform-background)'/*'#eee'*/, padding: 2,
                    boxSizing: 'border-box', fontSize: 14, paddingTop: 10, flex: 1
                }}
            >
                {item.name || structure.TITEL}
            </div>
            <div
                style={{
                    backgroundColor: 'var(--color-wform-background)'/*'#eee'*/, minWidth: 60, maxWidth: 60, padding: 2, textAlign: 'center',
                    marginLeft: 2, marginRight: 2, boxSizing: 'border-box', paddingTop: 8
                }}
            >
                <input
                    checked={auswahl}
                    onChange={(evt: any) => this.onChangeAuswahl(item.key, evt.target.checked)}
                    type='checkbox'
                    disabled={this.state.showSpinner}
                />
            </div>
            <div
                style={{
                    backgroundColor: 'var(--color-wform-background)'/*'#eee'*/, minWidth: 60, maxWidth: 60, padding: 2, textAlign: 'center',
                    boxSizing: 'border-box', paddingTop: 8
                }}
            >
                <input
                    checked={!auswahl}
                    onChange={(evt: any) => this.onChangeAuswahl(item.key, !evt.target.checked)}
                    type='checkbox'
                    disabled={this.state.showSpinner}
                />
            </div>
        </div>;
    }

    renderHeader(empty: boolean, showHelp: boolean): JSX.Element {
        let katInfo;
        switch (this.props.category) {
            case 'vsme_pat':
                katInfo = 'PAT-Modul';
                break;
            case 'vsme_bpm':
                katInfo = 'BPM-Modul';
                break;
        }
        return <div
            className={style.rowContainer}
            style={{ marginTop: 0, minHeight: 10 }}
        >
            <div
                style={{
                    color: 'white', backgroundColor: 'var(--color-section-main)'/*'#bccae3'*/, minWidth: 40, maxWidth: 40, padding: '4px 2px', lineHeight: 1,
                    textAlign: 'center', boxSizing: 'border-box', display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
                }}
                key={`div_${this.props.category}_header`}
            >
                {this.props.showHelpIcon && showHelp &&
                    <WHelpIcon
                        data={this.props.data}
                        styleDivProps={{ marginTop: 4, marginLeft: 0, display: 'flex', alignSelf: 'center' }}
                        styleProps={{ margin: 0 }}
                        label='Auswahl'
                        helpKey={`auswahl_${this.props.category}`}
                        type='theme_info'
                        style='theme_small'
                        editBar
                        useTheme
                        useWhite
                        // type='info'
                        // styleDivProps={{ display: 'inline-block' }}
                        // styleProps={{
                        //     width: 16, height: 16, borderRadius: 10, backgroundColor: '#fff', verticalAlign: 'top', margin: 0
                        // }}
                    />
                }
            </div>
            <div
                style={{
                    color: 'white', backgroundColor: 'var(--color-section-main)'/*'#bccae3'*/, padding: '4px 2px', lineHeight: 1,
                    boxSizing: 'border-box', fontSize: 16, fontWeight: 'bold', flex: 1, display: 'inline-flex', alignItems: 'center'
                }}
            >
                {!empty && `${katInfo} - Kategorie`}
            </div>
            <div
                style={{
                    color: 'white', backgroundColor: 'var(--color-section-main)'/*'#bccae3'*/, minWidth: 60, maxWidth: 60, padding: '4px 2px', textAlign: 'center', lineHeight: 1,
                    marginLeft: 2, marginRight: 2, boxSizing: 'border-box', fontSize: 16, display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
                }}
            >
                {!empty && 'Wird erfasst'}
            </div>
            <div
                style={{
                    color: 'white', backgroundColor: 'var(--color-section-main)'/*'#bccae3'*/, padding: '4px 2px', minWidth: 60, maxWidth: 60, textAlign: 'center', lineHeight: 1,
                    boxSizing: 'border-box', fontSize: 16, display: 'inline-flex', alignItems: 'center', justifyContent: 'center'
                }}
            >
                {!empty && 'Wird nicht erfasst'}
            </div>
        </div>;
    }

    renderJahresauswahl(): JSX.Element {
        return (
            <div>
                <DatenauswertungJahrauswahlEinzeln
                    jahrMin={this.state.jahrMin}
                    jahrMax={this.state.jahrMax}
                    jahr={this.state.jahr}
                    disabled={this.props.jahrFix ? true : false}
                    onJahrChange={(jahr: number) => {
                        this.contextService.set(`jahr_${this.props.category}_auswahl`, +jahr);
                        this.setState({ jahr: +jahr });
                    }}
                />
            </div>
        );
    }
}
